import React, { useEffect, useState } from 'react';
import { MktTopBarItem, MktTopBarNestableItem, LinkProps } from './TopBar';
import { useDropDown } from '../../hooks/useDropDown';
import clsx from 'clsx';
import { MktTopBarVariantsTypes, MktTopBarVariants } from './TopBar';

interface TopBarDropdownProps {
  items: MktTopBarNestableItem;
  isActive: boolean;
  linkComponent: React.FC<LinkProps>;
  onClick?: () => void;
  variant: MktTopBarVariants;
}

export const TopBarDropdown: React.FC<TopBarDropdownProps> = ({
  isActive,
  items,
  linkComponent,
  variant,
  onClick,
}) => {
  const Link = linkComponent;

  const [expandDropdown, setExpandDropdown] = useState<boolean>(isActive);

  useEffect(() => {
    setExpandDropdown(isActive);
  }, [isActive]);

  const { containerRef, linkRef } = useDropDown({ expanded: expandDropdown });
  const isLight = variant === MktTopBarVariantsTypes.light;

  return (
    <div
      className={clsx(
        'wh-group wh-overflow-hidden wh-transition-all',
        'lg:wh-absolute',
        isLight && 'lg:wh-bg-white',
        !isLight && 'lg:wh-bg-blue-dark',
        'lg:wh-top-[85px]',
        'lg:wh-left-0',
        'lg:wh-backdrop-blur-md',
        'wh-z-[10000]',
        'lg:wh-shadow-md',
      )}
      ref={containerRef}
    >
      <ul
        className={clsx(
          'group-aria-expanded:wh-pt-1',
          'wh-flex wh-flex-col wh-justify-center wh-gap-1 lg:wh-gap-[22px]',
          'lg:wh-px-4',
          'lg:wh-py-[30px]',
          'lg:wh-relative',
          'lg:wh-min-w-[180px]',
        )}
        ref={linkRef}
      >
        {items.subLinks &&
          items.subLinks.map((subLink: MktTopBarItem) => {
            return (
              <li key={subLink.id} className="lg:wh-pt-[10px] ">
                <Link
                  to={subLink.url}
                  onClick={onClick}
                  className={clsx(
                    `wh-block wh-text-base wh-font-regular ${
                      isLight || variant === MktTopBarVariantsTypes.transparent
                        ? 'wh-text-blue-dark'
                        : 'wh-text-mauve'
                    }  hover:wh-font-medium hover:wh-text-gold lg:wh-leading-[19.2px] lg:wh-tracking-[0.08px] ${
                      isLight
                        ? 'lg:wh-text-blue-dark lg:hover:wh-text-blue-dark'
                        : 'lg:wh-text-white lg:hover:wh-text-white'
                    }  lg:hover:wh-font-medium `,
                    {
                      'lg:wh-text-white lg:hover:wh-text-white':
                        variant === MktTopBarVariantsTypes.transparent,
                    },
                  )}
                >
                  {subLink.label}
                </Link>
              </li>
            );
          })}
      </ul>
    </div>
  );
};
